'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');
require('../../utils/colors.js');
require('../../utils/dates.js');
require('../../utils/numbers.js');
require('../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../utils/strings.js');
require('../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../utils/safeFetch.js');
require('../../utils/dom.js');
var Switch = _interopDefault(require('@material-ui/core/Switch'));

var setColor = function (customColor) {
    return customColor ? getThemeProp('', customColor) : getThemeProp('palette.primary.main', 'blue');
};
var StyledSwitch = styled__default(Switch)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  .MuiButtonBase-root {\n    &.Mui-checked {\n      color: ", ";\n      &:hover {\n        background-color: ", "24;\n      }\n      & + .MuiSwitch-track {\n        background-color: ", ";\n      }\n    }\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.14);\n    }\n  }\n"], ["\n  .MuiButtonBase-root {\n    &.Mui-checked {\n      color: ",
    ";\n      &:hover {\n        background-color: ",
    "24;\n      }\n      & + .MuiSwitch-track {\n        background-color: ",
    ";\n      }\n    }\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.14);\n    }\n  }\n"])), function (props) {
    return setColor(props.customColor);
}, function (props) {
    return setColor(props.customColor);
}, function (props) {
    return setColor(props.customColor);
});
var templateObject_1;

exports.StyledSwitch = StyledSwitch;
